var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mail-link",attrs:{"href":_vm.mailTarget}},[_vm._v("Send by email")])
}
var staticRenderFns = []

export { render, staticRenderFns }